const mediaItems = [
  {
    title: '热血战斗精选',
    desc: '《咒术回战》《鬼灭之刃》《进击的巨人》等超人气热血漫画一站式畅读，打斗场面张力十足。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20scene%20illustration%20in%20Japanese%20manga%20style%20with%20two%20warriors%20clashing%20swords%2C%20dramatic%20speed%20lines%20and%20impact%20effects%2C%20warm%20orange%20and%20red%20energy%20bursts%2C%20dark%20atmospheric%20background%20with%20floating%20embers%2C%20high%20contrast%20shonen%20art%20style%2C%20epic%20composition%20with%20cinematic%20lighting&width=800&height=500&seq=media-action-manga&orientation=landscape',
  },
  {
    title: '甜宠恋爱专区',
    desc: '《堀与宫村》《青春猪头少年》等温馨甜蜜恋爱漫画，每一页都让你心跳加速。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20illustration%20of%20two%20anime%20characters%20under%20cherry%20blossom%20trees%20in%20spring%2C%20gentle%20pink%20and%20cream%20color%20palette%2C%20floating%20petals%20and%20soft%20bokeh%20effects%2C%20shojo%20manga%20art%20style%20with%20delicate%20linework%2C%20warm%20sunset%20lighting%2C%20dreamy%20atmospheric%20scene&width=800&height=500&seq=media-romance-manga&orientation=landscape',
  },
  {
    title: '悬疑推理强推',
    desc: '《死亡笔记》《约定的梦幻岛》等烧脑悬疑作品，层层反转令人欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20atmosphere%20illustration%20with%20silhouetted%20figure%20in%20trench%20coat%20standing%20under%20streetlamp%20on%20foggy%20night%2C%20noir%20detective%20manga%20style%2C%20deep%20shadows%20and%20dramatic%20chiaroscuro%20lighting%2C%20rain%20slicked%20streets%20reflecting%20light%2C%20suspenseful%20mood%20with%20teal%20and%20amber%20color%20accents%2C%20cinematic%20composition&width=800&height=500&seq=media-mystery-manga&orientation=landscape',
  },
  {
    title: '奇幻异世界漫',
    desc: '《关于我转生变成史莱姆这档事》《Re:Zero》等异世界题材佳作，开启冒险新篇章。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20world%20illustration%20with%20floating%20islands%20and%20magical%20portals%20in%20vibrant%20anime%20art%20style%2C%20adventurer%20characters%20with%20swords%20and%20staffs%2C%20glowing%20crystals%20and%20ancient%20ruins%2C%20colorful%20skies%20with%20twin%20moons%2C%20isekai%20genre%20inspired%20composition%2C%20rich%20warm%20colors%20with%20golden%20and%20coral%20accents%2C%20epic%20scale%20landscape&width=800&height=500&seq=media-fantasy-manga&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑精选热门漫画分类，快速找到你的下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {mediaItems.map((m) => (
            <div
              key={m.title}
              className="group rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={m.img}
                  alt={`哔咔动漫${m.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-800">
                    <i className="ri-play-circle-line text-primary-500"></i>
                    点击浏览
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{m.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}